import CalculationRow from './CalculationRow';
import useCalculations from './useCalculations';

const Calculations: React.FunctionComponent = function ({}) {
  const { values, type, label, show } = useCalculations();
  if (!show) return undefined;
  return (
    <div className="mt-1 grid grid-cols-[1fr_1fr] text-16-24 w-full max-w-80 mx-auto gap-y-2 gap-x-2">
      <p className="text-16-24-em text-left">Terms</p>
      <p className="text-16-24-em text-right whitespace-nowrap">{label}</p>
      {values.map((value) => (
        <CalculationRow
          values={value}
          type={type}
          key={`${value.term}-${type}`}
        />
      ))}
    </div>
  );
};

export default Calculations;
